import {useMemo} from "react";

import {useGetRecommendedPropertiesQuery} from "../../../property/api/get_recommended_properties";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {Country} from "../../../region/types/Country";
import {recommendationsDistanceInKm} from "../../constants/multi_lead/application_multi_lead_constants";
import {ITinderMultiLeadState} from "../../types/tinder_multi_lead/ITinderMultiLeadState";
import {getStorageSentApplicationsList} from "../../utils/multi_lead/get_storage_sent_applications_id_list_by";

export function useTinderMultiLeadQueue(originProperty: IPropertyDetail | null, modalState: ITinderMultiLeadState) {
    const originOfferId = modalState.originOfferId || originProperty?.offer.id || 0;
    const excludedOfferIds = useMemo(() => {
        if (!modalState.isOpen || !originProperty) {
            return [originOfferId];
        }

        const sentOfferIds = getStorageSentApplicationsList(originProperty?.offer.region.country as Country | undefined).map((offer) => offer.id);

        return [originOfferId, ...sentOfferIds];
    }, [modalState.isOpen, originOfferId, originProperty]);

    const {data, isLoading, isSuccess, error} = useGetRecommendedPropertiesQuery(
        {
            propertyId: originProperty?.id || 0,
            excludedOfferIds,
            page: 1,
            page_size: 6,
            radius: recommendationsDistanceInKm
        },
        {
            skip: !modalState.isOpen || !originProperty
        }
    );

    const queue = useMemo(() => {
        const results = data?.results || [];
        return results.filter((property) => property.offer.id !== originOfferId);
    }, [data?.results, originOfferId]);

    return {
        activeProperty: queue[modalState.currentIndex] || null,
        error,
        isLoading,
        isSuccess,
        queue,
        totalCount: queue.length
    };
}
import {useMemo} from "react";

import {useGetRecommendedPropertiesQuery} from "../../../property/api/get_recommended_properties";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {Country} from "../../../region/types/Country";
import {recommendationsDistanceInKm} from "../../constants/multi_lead/application_multi_lead_constants";
import {ITinderMultiLeadState} from "../../types/tinder_multi_lead/ITinderMultiLeadState";
import {getStorageSentApplicationsList} from "../../utils/multi_lead/get_storage_sent_applications_id_list_by";

export function useTinderMultiLeadQueue(originProperty: IPropertyDetail | null, modalState: ITinderMultiLeadState) {
    const originOfferId = modalState.originOfferId || originProperty?.offer.id || 0;
    const excludedOfferIds = useMemo(() => {
        if (!modalState.isOpen || !originProperty) {
            return [originOfferId];
        }

        const sentOfferIds = getStorageSentApplicationsList(originProperty?.offer.region.country as Country | undefined).map((offer) => offer.id);

        return [originOfferId, ...sentOfferIds];
    }, [modalState.isOpen, originOfferId, originProperty]);

    const {data, isLoading, isSuccess, error} = useGetRecommendedPropertiesQuery(
        {
            propertyId: originProperty?.id || 0,
            excludedOfferIds,
            page: 1,
            page_size: 6,
            radius: recommendationsDistanceInKm
        },
        {
            skip: !modalState.isOpen || !originProperty
        }
    );

    const queue = useMemo(() => {
        const results = data?.results || [];
        return results.filter((property) => property.offer.id !== originOfferId);
    }, [data?.results, originOfferId]);

    return {
        activeProperty: queue[modalState.currentIndex] || null,
        error,
        isLoading,
        isSuccess,
        queue,
        totalCount: queue.length
    };
}
